import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import { mediaQueryUp } from 'components/utils/breakpoint'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import CategoryTile from 'LuxKit/CategoryTile'
import { ContentfulImageTextTile } from './ContentfulImageTiles/ContentfulImageTextTile'

const TravelPane = styled(Group)`
  padding: ${rem(24)} 0;
  background: ${props => props.theme.palette.neutral.default.eight};

  ${mediaQueryUp.tablet} {
    padding: ${rem(40)} 0;
  }
`

interface Props {
  title: string
  showTitle: boolean
  tiles: Array<any>
}
function ContentfulImageTileCarousel(props: Props) {
  const { title, tiles } = props
  // if there is one tile is componentImageTextTile, then we should not set the width to 180
  const shouldSetWidthTo180 = !tiles.some(tile => tile.contentTypeId === 'componentImageTextTile')

  return (
    <TravelPane direction="vertical" gap={20}>
      {props.showTitle && (
        <LayoutContainer>
          <Heading variant="heading2">{title}</Heading>
        </LayoutContainer>
      )}
      <FullWidthCarousel
        itemsPerArrow={6}
        snap="start"
        gap={12}
        width={shouldSetWidthTo180 ? rem(180) : undefined}
      >
        {tiles.map((tile: App.ComponentImageTileType) => {
          if (tile.contentTypeId === 'componentImageTile') {
            return <CategoryTile
              key={tile.linkTo}
              heading={tile.title}
              subHeading={tile.subtitle}
              align="top"
              callToAction={tile.linkText}
              to={tile.linkTo}
              image={tile.image}
            />
          }

          return <ContentfulImageTextTile {...tile} key={tile.linkTo} />
        })}
      </FullWidthCarousel>
    </TravelPane>
  )
}

export default ContentfulImageTileCarousel
